import React from "react";
import { NavLink } from "react-router-dom";

// Single source of truth for every link that appears in the site navigation.
const NAV_ITEMS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Blog", to: "/blogs" },
  { label: "Contact", to: "/contact" },
];

/**
 * Navigation renders the links that make up the site's navigation bar.
 * It is intentionally reusable: pass variant="desktop" for the inline
 * row shown next to the logo, or variant="mobile" for the dropdown panel
 * shown underneath the navbar once the hamburger button is tapped.
 */
const Navigation = ({ variant = "desktop", isOpen = false, onLinkClick }) => {
  if (variant === "mobile") {
    return (
      <div className={`mobile-menu${isOpen ? " open" : ""}`} id="mobile-menu">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            onClick={onLinkClick}
            className={({ isActive }) => (isActive ? "active" : undefined)}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    );
  }

  return (
    <div className="navbar-links">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/"}
          className={({ isActive }) =>
            `nav-link${isActive ? " active" : ""}`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  );
};

export default Navigation;
